import { DOCUMENT_ANIMATION } from '@Constants/types';

const initState = {
    run: false,
    cancel: false,
    abort: false
};

export default function analyzeDocumentAnimationReducer(state = initState, action) {
    switch (action.type) {
        case DOCUMENT_ANIMATION.RUN_ANIMATION:
            return { run: true, cancel: false, abort: false };
        case DOCUMENT_ANIMATION.STOP_ANIMATION:
            return { run: false, cancel: false, abort: false };
        case DOCUMENT_ANIMATION.CANCEL_ANIMATION:
            return { run: false, cancel: true, abort: false };
        case DOCUMENT_ANIMATION.ABORT_ANIMATION:
            return { run: false, cancel: false, abort: true };
        case DOCUMENT_ANIMATION.RESET_ANIMATION:
            return { ...initState };
        default:
            return state;
    }
}
